import React from "react";
import ExhibitionLogisticsRfqsSuperAdminView from "../../components/logistics/ExhibitionLogisticsRfqsSuperAdminView";

export default function ExhibitionLogisticsRfqsManagementPage({
  basePath = "/super-admin",
}) {
  return <ExhibitionLogisticsRfqsSuperAdminView basePath={basePath} />;
}
